/* eslint-disable camelcase */
import { DateTime } from 'luxon';
import { decamelizeKeys } from '../lib';
import api from './api';
import { getBackVersion } from '../config';

const track = (eventName: string, properties: unknown): Promise<unknown> =>
    api.request<unknown>({
        method: 'POST',
        url: `${getBackVersion()}/tracking`,
        data: {
            event_name: eventName,
            properties: properties,
        },
    });

const trackExternal = (
    eventName: string,
    properties: unknown
): Promise<unknown> =>
    api.request<unknown>({
        method: 'POST',
        url: `${getBackVersion()}/tracking/tracking_external`,
        data: {
            event_name: eventName,
            properties: properties,
        },
    });

type PageViewLibrary = {
    name: string | null;
    version: string | null;
};

type PageViewPageInfo = {
    path: string | null;
    referrer: string | null;
    search: string | null;
    title: string | null;
    url: string;
};

type PageViewTracking = {
    id: string;
    timestamp: string;
    campaign: Record<string, string>;
    library: PageViewLibrary;
    locale: string;
    page: PageViewPageInfo;
    timezone: string;
    fbp: string | null;
    fbc: string | null;
    utmstr: string | null;
};

const pageView = (payload: PageViewTracking): Promise<{ success: boolean }> =>
    api.request<{ success: boolean }>({
        method: 'POST',
        url: `${getBackVersion()}/tracking/page_view`,
        data: decamelizeKeys({
            ...payload,
            sentAt: DateTime.now().toISO(),
        }),
    });

export default { track, pageView, trackExternal };
